import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';

export type OrderCompleteProps = {
    onClose: () => void;
};

export const OrderComplete = ({ onClose }: OrderCompleteProps) => (
    <div className='display-flex flex-column'>
        <div className='border-color-gray margin-bottom-10 rounded border bg-white padding-10'>
            <div className='flex-column display-flex gap-5 text-center'>
                <span className='rioglyph rioglyph-ok-sign text-color-primary' style={{ fontSize: 90 }} />
                <span className='text-size-h1 text-color-dark'>
                    <FormattedMessage id='general.newOrder.congratulations.title' />
                </span>
                <span className='text-color-dark'>
                    <FormattedMessage id='general.newOrder.congratulations.description' />
                </span>
            </div>
            <div className='margin-top-20 btn-toolbar justify-content-center'>
                <Button className='width-120' onClick={onClose} bsStyle='primary'>
                    <FormattedMessage id='general.button.goToOrderHistory' />
                </Button>
            </div>
        </div>
    </div>
);
